import EbookApi from "@hibas123/lib-ebs";
import { enableLogging } from "./logging";

const config: {
   authserver: string;
   client_id: string;
   version: number;
} = (window as any).config;
if (!config) alert("Configuration not found, please reload!");

if (!config.version) {
   console.warn("Running in legacy mode!");
} else {
   console.info("Running with API version:", config.version);
}
const Api = new EbookApi(
   config.authserver,
   config.client_id,
   config.version || 0
);

enableLogging(Api.logging);

export { WorkChangeTypes, } from "@hibas123/lib-ebs";

export type {
   SmallWork,
   BaseChapter,
   BaseWork,
   FullChapter,
   FullWork,
   HttpError,
   Position,
   VerySmallWork,
} from "@hibas123/lib-ebs";
export default Api;
